require("@rails/ujs").start();
require("turbolinks").start();
require("@rails/activestorage").start();
require("channels");
  
import $ from 'jquery';
global.$ = jQuery;
import { createPopper } from '@popperjs/core';
import moment from 'moment';
window.moment = moment;
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
import "@fortawesome/fontawesome-free/js/all";
import "@fortawesome/fontawesome-free/css/all.css";
import "jquery.easing";
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
Swiper.use([Navigation]);
import 'swiper/swiper.scss';
import 'swiper/modules/navigation.scss'
window.Swiper = Swiper;
import SlimSelect from 'slim-select'

require("datatables.net-bs4");
require("datatables.net-select-bs4");

require("jquery-validation");

require("vendor/sb-admin-2");
require('bootstrap-select');
window.SlimSelect = SlimSelect;

import Highcharts from 'highcharts';
require("highcharts/modules/data")(Highcharts);
require("highcharts/modules/stock")(Highcharts);
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/offline-exporting")(Highcharts);
require("highcharts/modules/export-data")(Highcharts);
require("highcharts/modules/map")(Highcharts);
window.Highcharts = Highcharts;


window.FontAwesomeConfig = {
    searchPseudoElements: true,
}
document.addEventListener("turbolinks:load", () => {
    $('[data-bs-toggle="tooltip"]').tooltip();
    $('[data-bs-toggle="popover"]').popover();


    var locale = $('#locale').data()['locale'];

});

require("users_datatable.js");
require("program_sessions_datatable.js");
require("program_affiliations_datatable.js");
require("program_dashboard.js");
import "./jquery_cookie";
import "./tab_selector";
import "controllers";
import "./drag_questions";
import "./progress-bar";
import "./easepack.min";
import "./tweenlite.min";
